var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "id": _vm.id,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "click": function ($event) {
        return _vm.toggle();
      }
    }
  }), _c('label', {
    staticClass: "switch",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._m(0), _c('span', {
    staticClass: "switch__left w-1/2"
  }, [_vm._v("On")]), _c('span', {
    staticClass: "switch__right w-1/2"
  }, [_vm._v("Off")])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "switch__circle"
  }, [_c('span', {
    staticClass: "switch__circle-inner"
  })]);

}]

export { render, staticRenderFns }